import { Component } from '@angular/core';

import { BrandingService } from './shared/branding/branding.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(private readonly branding: BrandingService) {
    document.documentElement.setAttribute('data-brand', this.branding.brand.id);
  }

  title = 'SMS Notification Service';
}
